import { Button, Col, DatePicker, Form, Input, Row } from "antd";
import React from "react";
import moment from "moment";
import { useHistory } from "react-router";
import {
  displayFormat,
  infinityDateHttpFormat,
  toHttpFormat,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { useAppDispatch } from "../..";
import { createBlockingTypes } from "../../store/slices/blocking";
import RequiredMark from "../common/RequiredMark/RequiredMark";

function BlockingTypesAdminCreate() {
  const dateFormat = displayFormat;
  const dateEndForCreate = moment(infinityDateHttpFormat);

  const dispatch = useAppDispatch();
  const history = useHistory();

  const [form] = Form.useForm();

  const validateMessages = {
    required: "",
  };

  const onFinish = (fields) => {
    dispatch(
      createBlockingTypes({
        body: {
          ...fields,
          fromDate: fields.fromDate
            ? toHttpFormatStartOfDay(fields.fromDate)
            : toHttpFormatStartOfDay(moment()),
          toDate: toHttpFormat(fields.toDate),
          priority: Number(fields.priority),
        },
        onSuccess: () => {
          form.resetFields();
          history.push(`/blocking-types`);
        },
      })
    );
  };

  return (
    <div className="container_height">
      <div className="inner-row" style={{ marginBottom: "15px" }}>
        <Row align="middle" justify="space-between">
          <h1>Новый тип блокировки</h1>
        </Row>

        <Row>
          <Form
            style={{ width: "100%" }}
            form={form}
            validateMessages={validateMessages}
            name="advanced_search"
            className="profile-search-create-form"
            initialValues={{
              toDate: dateEndForCreate,
            }}
            onFinish={onFinish}
          >
            <Row className="profile-search-create-form__row-label" align="middle">
              <Col span={4}>
                <RequiredMark>
                  <label>Наименование</label>
                </RequiredMark>
              </Col>
              <Col span={3}>
                <RequiredMark>
                  <label>Приоритет</label>
                </RequiredMark>
              </Col>
              <Col span={4}>
                <RequiredMark>
                  <label>Alias</label>
                </RequiredMark>
              </Col>
              <Col span={3}>
                <label>Период действия</label>
              </Col>
            </Row>

            <Row
              className="profile-search-create-form__row-content"
              style={{ marginTop: "20px", marginBottom: "100px" }}
              align="top"
            >
              <Col span={4}>
                <Form.Item
                  className="create-form__col form-item-required__hidden-error__mb0"
                  name="name"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={3}>
                <Form.Item
                  className="create-form__col form-item-required__hidden-error__mb0"
                  name="priority"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input type="number" />
                </Form.Item>
              </Col>

              <Col span={4}>
                <Form.Item
                  className="create-form__col form-item-required__hidden-error__mb0"
                  name="alias"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={3}>
                <Form.Item
                  className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                  name="fromDate"
                >
                  <DatePicker
                    disabledDate={(current) => current.isAfter(dateEndForCreate.endOf("day"))}
                    format={dateFormat}
                    allowClear={false}
                  />
                </Form.Item>
              </Col>

              <Col span={3}>
                <Form.Item
                  className="profile-search-create-form__col form-item-required__hidden-error__mb0"
                  name="toDate"
                >
                  <DatePicker disabled format={dateFormat} allowClear={false} />
                </Form.Item>
              </Col>
            </Row>

            <Row
              align="middle"
              style={{ borderTop: "1px solid #CCDDEE", paddingTop: "10px" }}
              justify="center"
            >
              <Col
                span={24}
                style={{
                  textAlign: "center",
                }}
              >
                <Button
                  style={{
                    margin: "0 8px",
                  }}
                  onClick={() => {
                    form.resetFields();
                    history.push(`/blocking-types`);
                  }}
                >
                  Отмена
                </Button>
                <Button type="primary" htmlType="submit">
                  Сохранить
                </Button>
              </Col>
            </Row>
          </Form>
        </Row>
      </div>
    </div>
  );
}

export default BlockingTypesAdminCreate;
